import { writable } from 'svelte/store';
//import API from "Utils/api";


export const isCriticalError = writable(false)




isCriticalError.subscribe((value) => {

    //console.log("set critical Error " + value)
    if (value) {
        console.error("Critical Error")
        window.postMessage({ name: "resume_gameplay" }, "*");
        //API.closeSocket()

    }


})
